var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"40px"}}),_c('div',{staticClass:"bottom_nav_dev"},_vm._l((_vm.buttons),function(item,index){return _c('button',{key:index,staticClass:"button_dev",on:{"click":function($event){return _vm.goLink(item.link)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }